var map;
function initMap() {
    map = new google.maps.Map(document.getElementById('google_map'), {
        center: {lat: 51.2753796, lng: 22.54},
        zoom: 12,
        disableDefaultUI: true,
        backgroundColor: 'transparent',
        draggable: true, zoomControl: true, scrollwheel: false, disableDoubleClickZoom: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#46bcec"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ]
    });
    var iconBase = $('#google_map').data('pin-url');
    var icons = {
        rapa: {
            icon: iconBase
        }
    };

    var features = [{
        position: new google.maps.LatLng(51.2753796, 22.5676524),
        type: 'rapa'
    }];
    features.forEach(function(feature) {
        var marker = new google.maps.Marker({
            position: feature.position,
            url: "https://www.google.pl/maps/place/RAPA+-+manufacturer+of+refrigeration+equipment/@51.2743525,22.5087946,11.54z/data=!4m5!3m4!1s0x472250abcfed0fd7:0x5a0958dc279180ef!8m2!3d51.2751289!4d22.5670123",
            icon: icons[feature.type].icon,
            map: map
        });
        google.maps.event.addListener(marker, 'click', function() {
            window.open(marker.url);
        });
    });
}
$(document).ready(function() {
    let createMap = setInterval(function () {
        if ($('#google_map').html().length < 1) {
            initMap();
        } else {
            clearInterval(createMap);
        }
    }, 10);
});



// WEBPACK FOOTER //
// ./assets/js/front/contact.js